export interface TaskIdApi {
  taskId: string;
}

export let isTaskIdResponseDTO = (variable: unknown): variable is TaskIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "taskId" in variable &&
    typeof variable.taskId === "string"
  );
};
